module.exports = __webpack_public_path__ + "722fddde98ce8d68e3d50cd0a7b3dd8e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-10.png
// module id = 2450
// module chunks = 0